export default __webpack_public_path__ + "static/media/day4.2e01a068.png";